<div class="app-es-ocr-quick-fix-line-item-details">
  <div class="app-es-ocr-quick-fix-line-item-details__header">
    <div class="app-es-ocr-quick-fix-line-item-details__header__left">
      <p class="app-es-ocr-quick-fix-line-item-details__header__title">
        {{ lineItemTitle | uppercase }}
      </p>

      <app-hint-tooltip-icon [hint]="'ENTRY_SUMMARY.LINE_ITEM' | translate"></app-hint-tooltip-icon>
    </div>
  </div>

  <form [formGroup]="itemForm" autocomplete="off" (ngSubmit)="onSubmit()">
    <div class="form-row">
      <div class="col-12">
        <app-control-wrapper [control]="itemForm.get('description')" classHeader="d-flex justify-content-between" [errors]="errors">
          <label for="description" control-label>{{ "LABELS.ITEM_DESCRIPTION" | translate }}</label>
          <button
            *ngIf="isShowFindInCatalog"
            control-action-button
            type="button"
            class="btn btn-link shadow-none"
            (click)="findInCatalog()"
          >
            {{ "LABELS.FIND_IN_CATALOG" | translate }}
          </button>
          <textarea
            control-wrapper
            id="description"
            class="form-control"
            formControlName="description"
            [dropSpecialCharacters]="false"
            [patterns]="CUSTOM_MASK"
            [mask]="'F{60}'"
            [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
            [maxMaskLength]="60"
            [rows]="2"
            (input)="onFavoriteHtsItemsSearch()"
          ></textarea>
        </app-control-wrapper>

        <ng-container *ngIf="isShowFastSearch">
          <app-bina-catalog-fast-search-list
            [resultItems]="favoriteHtsNumberSearchedItems"
            [suggestions]="favoriteHtsSuggestions"
            [isShowCatalogLink]="isShowFindInCatalog"
            (htsInsert)="onCatalogPick($event)"
            (suggestionInsert)="onSuggestionPick($event)"
            (findInCatalog)="findInCatalog()"
            (clear)="clearSearchedFavoriteHtsItems()"
          ></app-bina-catalog-fast-search-list>
        </ng-container>
      </div>
    </div>

    <div class="form-row">
      <div class="col-8">
        <app-entry-hts-control
          [tooltipData]="'TOOLTIP.HTS_CODE_TOOLTIP' | translate"
          [fc]="itemForm.get('htsNumber')"
          [label]="'FORM_LABEL.HTS_CODE'"
          [isRequired]="isRequiredHtsNumber"
          [isDisableValidation]="isCustomBroker"
          (getHtsUnit)="getHtsUnits($event)"
          [helper]="'FORM_HELPER.ITEM_HTS_CODE'"
          [placeholder]="'NNNN.NN.NNNN'"
          [matchLength]="[10]"
          [arrivalDate]="arrivalDate"
          [shouldNotMatchHTSConfig]="shouldNotMatchHTSConfig.htsNumber"
        ></app-entry-hts-control>
      </div>

      <div class="col-4 text-right">
        <div class="find-hts">
          <button type="button" class="btn btn-outline-bordered" [class.find-hts__attention]="isHtsValidationNeeded" (click)="findHTS()">
            {{ findHtsLabelKey | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-12">
        <auto-select
          [errors]="errors"
          [fc]="itemForm.get('countryOfOriginId')"
          [id]="'countryOfOrigin'"
          [bindValue]="'id'"
          [bindLabel]="['code', 'description']"
          [clearable]="true"
          [initializeItems]="initCountryOfOrigin"
          [label]="'FORM_LABEL.COUNTRY_OF_ORIGIN'"
          [helper]="'FORM_HELPER.COUNTRY_OF_ORIGIN'"
          [change]="getCountries()"
        ></auto-select>
      </div>
    </div>

    <div *ngIf="showState" class="form-row">
      <div class="col-12">
        <auto-select
          [errors]="errors"
          [isShowHelper]="true"
          [fc]="itemForm.get('stateOfOrigin')"
          [id]="'stateOfOrigin'"
          [bindValue]="'code'"
          [bindLabel]="['code', 'description']"
          [clearable]="true"
          [initializeItems]="initStateOfOrigin"
          [label]="'FORM_LABEL.STATE_OF_ORIGIN'"
          [change]="getStates()"
        ></auto-select>
      </div>
    </div>

    <div class="form-row">
      <div class="col-6">
        <div class="form-row">
          <div class="col-12">
            <label for="grossWeight">{{ "LABELS.GROSS_WEIGHT" | translate }}</label>
          </div>

          <div class="col-12">
            <app-control-wrapper [control]="itemForm.get('grossWeight')" [errors]="errors" [isShowHelper]="false">
              <div class="d-flex" control-wrapper>
                <input
                  control-wrapper
                  id="grossWeight"
                  class="form-control"
                  formControlName="grossWeight"
                  type="text"
                  inputmode="numeric"
                  [pattern]="decimalInputMap.pattern"
                  [mask]="decimalInputMap.mask"
                  [dropSpecialCharacters]="false"
                  [appMaskErrorTooltip]="decimalInputMap.maskErrorTooltip"
                />
                <div class="form-control explanation">{{ WEIGHT_UNIT_KG }}</div>
              </div>
            </app-control-wrapper>
          </div>
        </div>
      </div>
      <div [ngClass]="{ 'col-12': invoiceCurrencyCode !== DEFAULT_CURRENCY_CODE, 'col-6': invoiceCurrencyCode === DEFAULT_CURRENCY_CODE }">
        <div class="form-row">
          <div class="col-12">
            <label for="value">
              {{ "FORM_LABEL.ENTERED_VALUE" | translate }}
              <span class="ml-1" *ngIf="invoiceCurrencyCode !== DEFAULT_CURRENCY_CODE">
                ({{ "FORM_LABEL.TODAY_EXCHANGE_RATE" | translate }})
              </span>
            </label>
          </div>

          <div
            [ngClass]="{
              'col-6': invoiceCurrencyCode !== DEFAULT_CURRENCY_CODE,
              'col-12': invoiceCurrencyCode === DEFAULT_CURRENCY_CODE
            }"
          >
            <app-control-wrapper [control]="itemForm.get('value')" [errors]="errors">
              <div class="d-flex" control-wrapper>
                <input
                  control-wrapper
                  id="value"
                  class="form-control currency"
                  formControlName="value"
                  type="text"
                  inputmode="numeric"
                  [pattern]="currencyInputMap.pattern"
                  [mask]="currencyInputMap.mask"
                  [thousandSeparator]="currencyInputMap.thousandSeparator"
                  [appMaskErrorTooltip]="currencyInputMap.maskErrorTooltip"
                />
                <div class="form-control explanation">{{ invoiceCurrencyCode }}</div>
              </div>
            </app-control-wrapper>
          </div>

          <div class="col-6" *ngIf="invoiceCurrencyCode !== DEFAULT_CURRENCY_CODE">
            <div class="form-group">
              <div class="d-flex">
                <input
                  id="second"
                  disabled
                  class="form-control currency"
                  [value]="itemForm.get('value').value * invoiceCurrencyRate | currency : DEFAULT_CURRENCY_CODE : '' : '1.2-2'"
                />
                <div class="form-control explanation">{{ DEFAULT_CURRENCY_CODE }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div formArrayName="units" *ngFor="let item of formUnits.controls; let i = index; let last = last">
      <div [formGroupName]="i">
        <div class="form-row">
          <div [ngClass]="{ 'col-4 col-md-5': isCustomBroker, 'col-5': !isCustomBroker }">
            <app-control-wrapper [control]="item.get('quantity' + (i + 1))" [errors]="errors" [isShowHelper]="false">
              <label for="quantity{{ i + 1 }}" control-label>{{ "LABELS.QUANTITY" | translate }} {{ i + 1 }}</label>
              <input
                control-wrapper
                id="quantity{{ i + 1 }}"
                class="form-control"
                formControlName="quantity{{ i + 1 }}"
                type="text"
                inputmode="numeric"
                [pattern]="decimalInputMap.pattern"
                [mask]="decimalInputMap.mask"
                [dropSpecialCharacters]="false"
                [appMaskErrorTooltip]="decimalInputMap.maskErrorTooltip"
              />
            </app-control-wrapper>
          </div>
          <div *ngIf="!isCustomBroker" class="col-7 col-md-5">
            <div class="form-group">
              <label>{{ "FORM_LABEL.UNIT_OF_MEASURE" | translate }} {{ i + 1 }}</label>
              <div class="form-control box">{{ item.get("unitOfMeasure" + (i + 1)).value }}</div>
            </div>
          </div>
          <div *ngIf="isCustomBroker" class="col-8 col-md-7">
            <button type="button" class="btn btn-link btn-unit-delete" (click)="removeUnit(i)">
              {{ "BUTTON.DELETE" | translate }}
            </button>
            <auto-select
              id="unitOfMeasure{{ i + 1 }}"
              [label]="('FORM_LABEL.UNIT_OF_MEASURE' | translate) + ' ' + (i + 1)"
              [requiredLabel]="false"
              [bindLabel]="['code']"
              [bindOption]="['code']"
              [bindValue]="'code'"
              [change]="searchUnits()"
              [fc]="item.get('unitOfMeasure' + (i + 1))"
              [errors]="errors"
              [isShowHelper]="false"
            ></auto-select>
          </div>
        </div>
      </div>
    </div>

    <div class="form-row mt-4">
      <div class="form-group">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" formControlName="hasNaftaNetCostIndicator" class="custom-control-input" id="hasNaftaNetCostIndicator" />
          <label class="custom-control-label" for="hasNaftaNetCostIndicator">
            {{ "FORM_LABEL.HAVE_TRADE_CERTIFICATE" | translate }}
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="isAddMode" class="app-es-ocr-quick-fix-line-item-details__add-button">
      <button type="button" class="btn btn-lg btn-square btn-primary" (click)="onSubmit()">
        {{ "BUTTON.ADD_LINE_ITEM" | translate }}
      </button>
    </div>

    <hr class="app-es-ocr-quick-fix-line-item-details__hr" />

    <div class="form-row">
      <div class="col-12">
        <button type="button" class="btn btn-link btn-remove" (click)="clearForm()">
          <i class="fa fa-trash"></i>
          {{ "FORM_LABEL.CLEAR_FORM" | translate }}
        </button>
      </div>
    </div>
  </form>

  <missing-fields [code]="'LABELS.ENTRY_SUMMARY'" (decline)="onSubmit(false)"></missing-fields>
</div>
